window.FINISHES_DATA = {
    "Lamitech® | Provincial Oak | 1501 MT": {
        brand: "Lamitech®",
        name: "Provincial Oak",
        colorCode: "1501 MT",
        orderSample: "https://www.lamitech.co/productos/179_provincial_oak"
    },
    "Lamitech® | Okumen | 1535 MT": {
        brand: "Lamitech®",
        name: "Okumen",
        colorCode: "1535 MT",
        orderSample: "https://www.lamitech.co/productos/171_okumen"
    },
    "Lamitech® | Neutral Oak | 1498 MT": {
        brand: "Lamitech®",
        name: "Neutral Oak",
        colorCode: "1498 MT",
        orderSample: "https://www.lamitech.co/productos/166_neutral_oak"
    },
    "Lamitech® | Olive Elm | 1503 MT": {
        brand: "Lamitech®",
        name: "Olive Elm",
        colorCode: "1503 MT",
        orderSample: "https://www.lamitech.co/productos/172_olive_elm"
    },
    "Lamitech® | Italian Walnut | 1513 MT": {
        brand: "Lamitech®",
        name: "Italian Walnut",
        colorCode: "1513 MT",
        orderSample: "https://www.lamitech.co/productos/158_italian_walnut"
    },
    "Lamitech® | Larice Rustico | 1464": {
        brand: "Lamitech®",
        name: "Larice Rustico",
        colorCode: "1464",
        orderSample: "https://www.lamitech.co/productos/160_larice_rustico"
    },
    "Lamitech® | Rural Pine | 1505": {
        brand: "Lamitech®",
        name: "Rural Pine",
        colorCode: "1505",
        orderSample: "https://www.lamitech.co/productos/187_rural_pine"
    },
    "Lamitech® | Hard Rock Maple | 0791 MT": {
        brand: "Lamitech®",
        name: "Hard Rock Maple",
        colorCode: "0791 MT",
        orderSample: "https://www.lamitech.co/productos/155_hard_rock_maple?lang=en"
    },
    "Lamitech® | Bleached Maple | 1322 MT": {
        brand: "Lamitech®",
        name: "Bleached Maple",
        colorCode: "1322 MT",
        orderSample: "https://www.lamitech.co/productos/162_maple_claro"
    },
    "Lamitech® | White Oak | 1336 MT": {
        brand: "Lamitech®",
        name: "White Oak",
        colorCode: "1336 MT",
        orderSample: "https://www.lamitech.co/productos/205_white_oak"
    },
    "Wilsonart® | Beigewood | 7850-60": {
        brand: "Wilsonart®",
        name: "Beigewood",
        colorCode: "7850-60",
        orderSample: "https://www.wilsonart.com/beigewood-7850"
    },
    "Wilsonart® | Phantom Pearl | 8211K-28": {
        brand: "Wilsonart®",
        name: "Phantom Pearl",
        colorCode: "8211K-28",
        orderSample: "https://www.wilsonart.com/phantom-pearl-8211"
    },
    "Wilsonart® | Field Elm | 7999K-12": {
        brand: "Wilsonart®",
        name: "Field Elm",
        colorCode: "7999K-12",
        orderSample: "https://www.wilsonart.com/field-elm-7999"
    },
    "Wilsonart® | Ebony Char | 8205K-16": {
        brand: "Wilsonart®",
        name: "Ebony Char",
        colorCode: "8205K-16",
        orderSample: "https://www.wilsonart.com/ebony-char-8205"
    },
    "Wilsonart® | Madagascar | 7944K-01": {
        brand: "Wilsonart®",
        name: "Madagascar",
        colorCode: "7944K-01",
        orderSample: "https://www.wilsonart.com/madagascar-7944"
    },
    "Egger® | Natural Halifax Oak | H1180 ST37": {
        brand: "Egger®",
        name: "Natural Halifax Oak",
        colorCode: "H1180 ST37",
        orderSample: "https://www.egger.com/en/furniture-interior-design/decors/H1180_37?country=CA"
    },
    "Egger® | White Halifax Oak | H1176 ST37": {
        brand: "Egger®",
        name: "White Halifax Oak",
        colorCode: "H1176 ST37",
        orderSample: "https://www.egger.com/en/furniture-interior-design/decors/H1176_37?country=CA"
    },
    "Egger® | Grey-Beige Tossini Elm | H1210 ST12": {
        brand: "Egger®",
        name: "Grey-Beige Tossini Elm",
        colorCode: "H1210 ST12",
        orderSample: "https://www.egger.com/en/furniture-interior-design/decors/H1210_12"
    },
    "Egger® | Stone Grey Frozen Wood | H1288 ST19": {
        brand: "Egger®",
        name: "Stone Grey Frozen Wood",
        colorCode: "H1288 ST19",
        orderSample: "https://www.egger.com/en/furniture-interior-design/decors/H1288_19"
    },
    "Egger® | Fox Grey Tossini Elm | H1222 ST12": {
        brand: "Egger®",
        name: "Fox Grey Tossini Elm",
        colorCode: "H1222 ST12",
        orderSample: "https://www.egger.com/en/furniture-interior-design/decors/H1222_12"
    },
    "Egger® | Carbon Frozen Wood | H1292 ST19": {
        brand: "Egger®",
        name: "Carbon Frozen Wood",
        colorCode: "H1292 ST19",
        orderSample: "https://www.egger.com/en/furniture-interior-design/decors/H1292_19?country=CA"
    },
    "TAFISA® | Crème de la Crème | T2031 (BV)": {
        brand: "TAFISA®",
        name: "Crème de la Crème",
        colorCode: "T2031 (BV)",
        orderSample: "https://tafisa.ca/en/our-colours/creme-de-la-creme"
    },
    "TAFISA® | Love at First Sight | T590 (KA)": {
        brand: "TAFISA®",
        name: "Love at First Sight",
        colorCode: "T590 (KA)",
        orderSample: "https://tafisa.ca/en/our-colours/love-at-first-sight"
    },
    "TAFISA® | Kiss Curl | T592PM": {
        brand: "TAFISA®",
        name: "Kiss Curl",
        colorCode: "T592PM",
        orderSample: "https://tafisa.ca/en/our-colours/kiss-curl-0"
    },
    "TAFISA® | Sugar on Ice | T2014 (VA)": {
        brand: "TAFISA®",
        name: "Sugar on Ice",
        colorCode: "T2014 (VA)",
        orderSample: "https://tafisa.ca/en/our-colours/sugar-on-ice"
    },
    "TAFISA® | Niagara | T544 (AT)": {
        brand: "TAFISA®",
        name: "Niagara",
        colorCode: "T544 (AT)",
        orderSample: "https://tafisa.ca/en/our-colours/niagara"
    },
    "TAFISA® | Nutmeg | 350": {
        brand: "TAFISA®",
        name: "Nutmeg",
        colorCode: "350",
        orderSample: "https://tafisa.ca/en/our-colours/nutmeg"
    },
    "Lamitech® | Imperiale | 3157 PL": {
        brand: "Lamitech®",
        name: "Imperiale",
        colorCode: "3157 PL",
        orderSample: "https://www.lamitech.co/productos/644_imperiale?lang=en"
    },
    "Lamitech® | Marina Di Carrara | 3151 MT": {
        brand: "Lamitech®",
        name: "Marina Di Carrara",
        colorCode: "3151 MT",
        orderSample: "https://www.lamitech.co/productos/642_marina_di_carrara"
    },
    "Lamitech® | Quarzite | 3044 GL": {
        brand: "Lamitech®",
        name: "Quarzite",
        colorCode: "3044 GL",
        orderSample: "https://www.lamitech.co/productos/301_quarzite"
    },
    "Lamitech® | Santo Branco | 3125 GL": {
        brand: "Lamitech®",
        name: "Santo Branco",
        colorCode: "3125 GL",
        orderSample: "http://www.lamitech.co/productos/305_santo_branco"
    },
    "Lamitech® | Grey Slate | 3156": {
        brand: "Lamitech®",
        name: "Grey Slate",
        colorCode: "3156",
        orderSample: "https://www.lamitech.co/productos/346_grey_slate"
    },
    "Wilsonart® | Oxide | 1787": {
        brand: "Wilsonart®",
        name: "Oxide",
        colorCode: "1787",
        orderSample: "https://www.wilsonart.com/oxide-1787"
    },
    "Wilsonart® | Cote Dazur | 1886": {
        brand: "Wilsonart®",
        name: "Cote Dazur",
        colorCode: "1886",
        orderSample: "https://www.wilsonart.com/cote-d-azur-1886"
    },
    "Wilsonart® | Benjamin Grey | 1887": {
        brand: "Wilsonart®",
        name: "Benjamin Grey",
        colorCode: "1887",
        orderSample: "https://www.wilsonart.com/benjamin-grey-1887"
    },
    "Wilsonart® | Navy Legacy | 4651": {
        brand: "Wilsonart®",
        name: "Navy Legacy",
        colorCode: "4651",
        orderSample: "https://www.wilsonart.com/navy-legacy-4651"
    },
    "Wilsonart® | Pewter Brush | 4779": {
        brand: "Wilsonart®",
        name: "Pewter Brush",
        colorCode: "4779",
        orderSample: "https://www.wilsonart.com/pewter-brush-4779"
    },
    "Wilsonart® | Windswept Pewter | 4795": {
        brand: "Wilsonart®",
        name: "Windswept Pewter",
        colorCode: "4795",
        orderSample: "https://www.wilsonart.com/windswept-pewter-4795"
    },
    "Wilsonart® | Bronzite | 4971": {
        brand: "Wilsonart®",
        name: "Bronzite",
        colorCode: "4971",
        orderSample: "https://www.wilsonart.com/bronzite-4971"
    },
    "Wilsonart® | Portoro | 4980": {
        brand: "Wilsonart®",
        name: "Portoro",
        colorCode: "4980",
        orderSample: "https://www.wilsonart.com/portoro-4980"
    },
    "Wilsonart® | Dusk Cascade | 5004": {
        brand: "Wilsonart®",
        name: "Dusk Cascade",
        colorCode: "5004",
        orderSample: "https://www.wilsonart.com/dusk-cascade-5004"
    },
    "Wilsonart® | Sierra Cascade | 5005": {
        brand: "Wilsonart®",
        name: "Sierra Cascade",
        colorCode: "5005",
        orderSample: "https://www.wilsonart.com/sierra-cascade-5005"
    },
    "Formica® | White Marble | 9310-58": {
        brand: "Formica®",
        name: "White Marble",
        colorCode: "9310-58",
        orderSample: "https://www.formica.com/en-us/products/cmpct/09310"
    },
    "Formica® | White Shalestone | 9525-58": {
        brand: "Formica®",
        name: "White Shalestone",
        colorCode: "9525-58",
        orderSample: "https://www.formica.com/products/lamtrade/09525"
    },
    "Formica® | Patine Bronze | 3707-58": {
        brand: "Formica®",
        name: "Patine Bronze",
        colorCode: "3707-58",
        orderSample: "https://www.formica.com/en-us/products/lamtrade/03707"
    },
    "Formica® | Earth Wash | 7213-58": {
        brand: "Formica®",
        name: "Earth Wash",
        colorCode: "7213-58",
        orderSample: "https://www.formica.com/en-us/products/lamhome/07213"
    },
    "Formica® | Silver Shalestone | 9307-58": {
        brand: "Formica®",
        name: "Silver Shalestone",
        colorCode: "9307-58",
        orderSample: "https://www.formica.com/en-us/products/lamtrade/09307"
    },
    "Formica® | Elemental Concrete | 8830-58": {
        brand: "Formica®",
        name: "Elemental Concrete",
        colorCode: "8830-58",
        orderSample: "https://www.formica.com/en-us/products/lamhome/08830"
    },
    "Lamitech® | Industrial Concrete | 3127 MT": {
        brand: "Lamitech®",
        name: "Industrial Concrete",
        colorCode: "3127 MT",
        orderSample: "https://www.lamitech.co/productos/303_industrial_concrete"
    },
    "Wilsonart® | Ebony Fusion | 1799K-07": {
        brand: "Wilsonart®",
        name: "Ebony Fusion",
        colorCode: "1799K-07",
        orderSample: "https://www.wilsonart.com/ebony-fusion-1799"
    },
    "Wilsonart® | Marmo Bianco | 1835K-07": {
        brand: "Wilsonart®",
        name: "Marmo Bianco",
        colorCode: "1835K-07",
        orderSample: "https://www.wilsonart.com/marmo-bianco-1885"
    },
    "Formica® | White | 949-58": {
        brand: "Formica®",
        name: "White",
        colorCode: "949-58",
        orderSample: "https://www.formica.com/en-us/products/lamtrade/00949/"
    },
    "Formica® | Dover White | 7197-58": {
        brand: "Formica®",
        name: "Dover White",
        colorCode: "7197-58",
        orderSample: "https://www.formica.com/en-us/products/lamhome/07197"
    },
    "Formica® | Mojave | 8751": {
        brand: "Formica®",
        name: "Mojave",
        colorCode: "8751",
        orderSample: "https://www.formica.com/en-us/products/lamtrade/08751"
    },
    "Formica® | Gull Grey | 9242": {
        brand: "Formica®",
        name: "Gull Grey",
        colorCode: "9242",
        orderSample: "https://www.formica.com/en-us/products/lamtrade/09242"
    },
    "Formica® | Fog | 961": {
        brand: "Formica®",
        name: "Fog",
        colorCode: "961",
        orderSample: "https://www.formica.com/en-us/products/lamtrade/00961"
    },
    "Formica® | Winter Sky | 8792": {
        brand: "Formica®",
        name: "Winter Sky",
        colorCode: "8792",
        orderSample: "https://www.formica.com/en-us/products/lamtrade/08792"
    },
    "Formica® | Purple Dye | 1196": {
        brand: "Formica®",
        name: "Purple Dye",
        colorCode: "1196",
        orderSample: "https://www.formica.com/en-us/products/lamtrade/01196"
    },
    "Formica® | Black | 909": {
        brand: "Formica®",
        name: "Black",
        colorCode: "909",
        orderSample: "https://www.formica.com/en-us/products/lamtrade/00909"
    },
    "Formica® | Navy Blue | 969": {
        brand: "Formica®",
        name: "Navy Blue",
        colorCode: "969",
        orderSample: "https://www.formica.com/en-us/products/lamtrade/00969"
    },
    "Formica® | Matrix Blue | 8795": {
        brand: "Formica®",
        name: "Matrix Blue",
        colorCode: "8795",
        orderSample: "https://www.formica.com/en-us/products/lamtrade/08795"
    },
    "Wilsonart® | Indigo | D379": {
        brand: "Wilsonart®",
        name: "Indigo",
        colorCode: "D379",
        orderSample: "https://www.wilsonart.com/laminate/designs/all-designs/indigo-d379.html"
    },
    "Wilsonart® | Lapis Blue | D417": {
        brand: "Wilsonart®",
        name: "Lapis Blue",
        colorCode: "D417",
        orderSample: "https://www.wilsonart.com/lapis-blue-d417"
    },
    "Wilsonart® | Orange Grove | D501": {
        brand: "Wilsonart®",
        name: "Orange Grove",
        colorCode: "D501",
        orderSample: "https://www.wilsonart.com/orange-grove-d501"
    },
    "Lamitech® | Brun | 2314": {
        brand: "Lamitech®",
        name: "Brun",
        colorCode: "2314",
        orderSample: "https://www.lamitech.co/productos/92_brun"
    },
    "Lamitech® | Grafito | 2174": {
        brand: "Lamitech®",
        name: "Grafito",
        colorCode: "2174",
        orderSample: "https://www.lamitech.co/productos/93_grafito"
    },
    "Lamitech® | Red Pepper | 2238": {
        brand: "Lamitech®",
        name: "Red Pepper",
        colorCode: "2238",
        orderSample: "https://www.lamitech.co/productos/100_red_pepper"
    },
    "Lamitech® | Ink | 2234": {
        brand: "Lamitech®",
        name: "Ink",
        colorCode: "2234",
        orderSample: "https://www.lamitech.co/productos/108_ink"
    },
    "Lamitech® | Fashion White | 2125": {
        brand: "Lamitech®",
        name: "Fashion White",
        colorCode: "2125",
        orderSample: "https://www.lamitech.co/productos/70_fashion_white"
    },
    "Lamitech® | Vanilla | 2109": {
        brand: "Lamitech®",
        name: "Vanilla",
        colorCode: "2109",
        orderSample: "https://www.lamitech.co/productos/71_vanilla"
    },
    "Lamitech® | Fog | 2108": {
        brand: "Lamitech®",
        name: "Fog",
        colorCode: "2108",
        orderSample: "https://www.lamitech.co/productos/85_humo"
    },
    "Lamitech® | Graphite | 2174": {
        brand: "Lamitech®",
        name: "Graphite",
        colorCode: "2174",
        orderSample: "https://www.lamitech.co/productos/93_grafito"
    },
    "Lamitech® | Gold | 2152": {
        brand: "Lamitech®",
        name: "Gold",
        colorCode: "2152",
        orderSample: "https://www.lamitech.co/productos/127_Gold"
    },
    "Lamitech® | Orangine | 2295": {
        brand: "Lamitech®",
        name: "Orangine",
        colorCode: "2295",
        orderSample: "https://www.lamitech.co/productos/130_orangine"
    },
    "Lamitech® | Burgundy | 2158": {
        brand: "Lamitech®",
        name: "Burgundy",
        colorCode: "2158",
        orderSample: "https://www.lamitech.co/productos/96_burgundy"
    },
    "Lamitech® | Eggplant | 2243": {
        brand: "Lamitech®",
        name: "Eggplant",
        colorCode: "2243",
        orderSample: "https://www.lamitech.co/productos/106_eggplant"
    },
    "Lamitech® | Pacific Blue | 2170": {
        brand: "Lamitech®",
        name: "Pacific Blue",
        colorCode: "2170",
        orderSample: "https://www.lamitech.co/productos/109_pacific_blue"
    },
    "Lamitech® | Lapizlasuli | 0888": {
        brand: "Lamitech®",
        name: "Lapizlasuli",
        colorCode: "0888",
        orderSample: "https://www.lamitech.co/productos/110_lapizl%C3%A1suli"
    },
    "Lamitech® | Petroleo | 2237": {
        brand: "Lamitech®",
        name: "Petroleo",
        colorCode: "2237",
        orderSample: "https://www.lamitech.co/productos/116_petrol"
    },
    "Lamitech® | Mint | 2236": {
        brand: "Lamitech®",
        name: "Mint",
        colorCode: "2236",
        orderSample: "https://www.lamitech.co/productos/120_mint"
    },
    "Chemetal® | Brushed Light Brass Aluminum | 904": {
        brand: "Chemetal®",
        name: "Brushed Light Brass Aluminum",
        colorCode: "904",
        orderSample: "https://www.chemetal.com/designs/904-brushed-light-brass-aluminum/"
    },
    "Chemetal® | Brushed Aluminum | 902": {
        brand: "Chemetal®",
        name: "Brushed Aluminum",
        colorCode: "902",
        orderSample: "https://www.chemetal.com/designs/902-brushed-aluminum/"
    },
    "Chemetal® | Civilization Aluminum | 620": {
        brand: "Chemetal®",
        name: "Civilization Aluminum",
        colorCode: "620",
        orderSample: "https://www.chemetal.com/designs/620-civilization-aluminum/"
    },
    "Chemetal® | Gilt Aluminum | 609": {
        brand: "Chemetal®",
        name: "Gilt Aluminum",
        colorCode: "609",
        orderSample: "https://www.chemetal.com/designs/609-gilt-aluminum/"
    },
    "Chemetal® | Cleopatra Aluminum | 629": {
        brand: "Chemetal®",
        name: "Cleopatra Aluminum",
        colorCode: "629",
        orderSample: "https://www.chemetal.com/designs/337-aged-brass/"
    },
    "Chemetal® | Brushed Black Aluminum | 917": {
        brand: "Chemetal®",
        name: "Brushed Black Aluminum",
        colorCode: "917",
        orderSample: "https://www.chemetal.com/designs/917-brushed-black-aluminum/"
    },
    "Chemetal® | Rose Gold Aluminum | 933": {
        brand: "Chemetal®",
        name: "Rose Gold Aluminum",
        colorCode: "933",
        orderSample: "https://www.chemetal.com/designs/933-rose-gold-aluminum/"
    },
    "Chemetal® | Light Bronze Aluminum | 934": {
        brand: "Chemetal®",
        name: "Light Bronze Aluminum",
        colorCode: "934",
        orderSample: "https://www.chemetal.com/designs/934-light-bronze-aluminum/"
    },
    "Chemetal® | Champagne Satin Aluminum | 946": {
        brand: "Chemetal®",
        name: "Champagne Satin Aluminum",
        colorCode: "946",
        orderSample: "https://www.chemetal.com/designs/946-champagne-satin-aluminum/"
    },
    "Chemetal® | Footplate | 216": {
        brand: "Chemetal®",
        name: "Footplate",
        colorCode: "216",
        orderSample: "https://www.chemetal.com/designs/216-footplate/"
    },
    "Chemetal® | Venetian Horizontal | 227": {
        brand: "Chemetal®",
        name: "Venetian Horizontal",
        colorCode: "227",
        orderSample: "https://www.chemetal.com/designs/227-venetian-horizontal/"
    },
    "Chemetal® | Moonscape | 230": {
        brand: "Chemetal®",
        name: "Moonscape",
        colorCode: "230",
        orderSample: "https://www.chemetal.com/designs/230-moonscape/"
    },
    "Chemetal® | Metawave Bronze Aluminum | 236": {
        brand: "Chemetal®",
        name: "Metawave Bronze Aluminum",
        colorCode: "236",
        orderSample: "https://www.chemetal.com/designs/236-metawave-bronze-aluminum/"
    },
    "Chemetal® | Metawave Black Aluminum | 239": {
        brand: "Chemetal®",
        name: "Metawave Black Aluminum",
        colorCode: "239",
        orderSample: "https://www.chemetal.com/designs/239-metawave-black-aluminum/"
    },
    "Chemetal® | Red Rock | 262": {
        brand: "Chemetal®",
        name: "Red Rock",
        colorCode: "262",
        orderSample: "https://www.chemetal.com/designs/262-red-rock/"
    },
    "Chemetal® | Canterbury | 315": {
        brand: "Chemetal®",
        name: "Canterbury",
        colorCode: "315",
        orderSample: "https://www.chemetal.com/designs/315-canterbury/"
    },
    "Chemetal® | Aurora | 317": {
        brand: "Chemetal®",
        name: "Aurora",
        colorCode: "317",
        orderSample: "https://www.chemetal.com/designs/317-aurora/"
    },
    "Chemetal® | Monet | 340": {
        brand: "Chemetal®",
        name: "Monet",
        colorCode: "340",
        orderSample: "https://www.chemetal.com/designs/340-monet/"
    },
    "Chemetal® | Alu Medium | 353": {
        brand: "Chemetal®",
        name: "Alu Medium",
        colorCode: "353",
        orderSample: "https://www.chemetal.com/designs/353-alu-medium/"
    },
    "Chemetal® | Circles | 406": {
        brand: "Chemetal®",
        name: "Circles",
        colorCode: "406",
        orderSample: "https://www.chemetal.com/designs/406-circles/"
    },
    "Chemetal® | Weathered Aluminum | 600": {
        brand: "Chemetal®",
        name: "Weathered Aluminum",
        colorCode: "600",
        orderSample: "https://www.chemetal.com/designs/600-weathered-aluminum/"
    },
    "Chemetal® | Core Aluminum | 607": {
        brand: "Chemetal®",
        name: "Core Aluminum",
        colorCode: "607",
        orderSample: "https://www.chemetal.com/designs/607-core-aluminum/"
    },
    "Chemetal® | Khaleesi Aluminum | 610": {
        brand: "Chemetal®",
        name: "Khaleesi Aluminum",
        colorCode: "610",
        orderSample: "https://www.chemetal.com/designs/610-khaleesi-aluminum/"
    },
    "Chemetal® | Ember Aluminum | 613": {
        brand: "Chemetal®",
        name: "Ember Aluminum",
        colorCode: "613",
        orderSample: "https://www.chemetal.com/designs/613-ember-aluminum/"
    },
    "Chemetal® | Beowulf Aluminum | 614": {
        brand: "Chemetal®",
        name: "Beowulf Aluminum",
        colorCode: "614",
        orderSample: "https://www.chemetal.com/designs/614-beowulf-aluminum/"
    },
    "Chemetal® | Satin Copper | 706": {
        brand: "Chemetal®",
        name: "Satin Copper",
        colorCode: "706",
        orderSample: "https://www.chemetal.com/designs/706-satin-copper/"
    },
    "Chemetal® | Brushed Stainless Steel | 710": {
        brand: "Chemetal®",
        name: "Brushed Stainless Steel",
        colorCode: "710",
        orderSample: "https://www.chemetal.com/designs/710-brushed-stainless-steel/"
    },
    "Chemetal® | Black Brushed Aluminum | 717": {
        brand: "Chemetal®",
        name: "Black Brushed Aluminum",
        colorCode: "717",
        orderSample: "https://www.chemetal.com/designs/717-black-brushed-aluminum/"
    },
    "Chemetal® | Oiled Bronze Aluminum | 721": {
        brand: "Chemetal®",
        name: "Oiled Bronze Aluminum",
        colorCode: "721",
        orderSample: "https://www.chemetal.com/designs/721-oiled-bronze-aluminum/"
    },
    "Chemetal® | Light Brushed Bronze Aluminum | 722": {
        brand: "Chemetal®",
        name: "Light Brushed Bronze Aluminum",
        colorCode: "722",
        orderSample: "https://www.chemetal.com/designs/722-light-brushed-bronze-aluminum/"
    },
    "Chemetal® | Champagne Brushed Aluminum | 724": {
        brand: "Chemetal®",
        name: "Champagne Brushed Aluminum",
        colorCode: "724",
        orderSample: "https://www.chemetal.com/designs/724-champagne-brushed-aluminum/"
    },
    "Chemetal® | Satin Bronze Aluminum | 912": {
        brand: "Chemetal®",
        name: "Satin Bronze Aluminum",
        colorCode: "912",
        orderSample: "https://www.chemetal.com/designs/912-satin-bronze-aluminum/"
    },
    "Chemetal® | Satin Copper Aluminum | 919": {
        brand: "Chemetal®",
        name: "Satin Copper Aluminum",
        colorCode: "919",
        orderSample: "https://www.chemetal.com/designs/919-satin-copper-aluminum/"
    },
    "Chemetal® | Brushed Medium Bronze Aluminum | 925": {
        brand: "Chemetal®",
        name: "Brushed Medium Bronze Aluminum",
        colorCode: "925",
        orderSample: "https://www.chemetal.com/designs/925-brushed-medium-bronze-aluminum/"
    },
    "Chemetal® | Flux | 276": {
        brand: "Chemetal®",
        name: "Flux",
        colorCode: "276",
        orderSample: "https://www.chemetal.com/designs/276-flux/"
    },
    "Chemetal® | Flux Smoked | 277": {
        brand: "Chemetal®",
        name: "Flux Smoked",
        colorCode: "277",
        orderSample: "https://www.chemetal.com/designs/277-flux-smoked/"
    }
};

window.INSERTS_DATA = 
{
    EAS328S1: { 
        brand: "Elica",
        price: "439",
        model: "EAS328S1",
        cfm: "300", 
        convertible: true, 
        ductSize: "6"
    },
    EPR628S2: {
        brand: "Elica",
        price: "929",
        model: "EPR628S2",
        cfm: "600",
        convertible: true,
        ductSize: "6"
    },
    INSP28SS240: {
        brand: "Faber",
        price: "449",
        model: "INSP28SS240",
        cfm: "240",
        convertible: true,
        ductSize: "5"
    },
    INLX28SSV2: {
        brand: "Faber",
        price: "969",
        model: "INLX28SSV2",
        cfm: "600",
        convertible: true,
        ductSize: "6"
    },
    EAS430S1: {
        brand: "Elica",
        price: "569",
        model: "EAS430S1",
        cfm: "400",
        convertible: true,
        ductSize: "6"
    },
    AK8134BS: {
        brand: "Zephyr",
        price: "949",
        model: "AK8134BS",
        cfm: "600",
        convertible: true,
        ductSize: "6"
    },
    EUM634S1: {
        brand: "Elica",
        price: "989",
        model: "EUM634S1",
        cfm: "600",
        convertible: true,
        ductSize: "6"
    },
    INSD35SSV: {
        brand: "Faber",
        price: "1019",
        model: "INSD35SSV",
        cfm: "600",
        convertible: true,
        ductSize: "6"
    },
    XOI4515KSE: {
        brand: "XO",
        price: "1750",
        model: "XOI4515KSE",
        cfm: "1000",
        convertible: false,
        ductSize: "8"
    }
};

